import {
  ClinicalTrial,
  ClinicalTrialsCancerTypesResponse,
  ClinicalTrialsSearchParams,
  ClinicalTrialsSearchResponse,
} from './types';

export const searchClinicalTrials = async (
  params: ClinicalTrialsSearchParams
): Promise<ClinicalTrialsSearchResponse> => {
  const response = await fetch('/api/clinical-trials/search', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    throw new Error(`Clinical trials search failed (${response.status})`);
  }

  return response.json();
};

export const fetchCancerTypes = async (
  params: Pick<ClinicalTrialsSearchParams, 'sponsor' | 'studyIds'>
): Promise<string[]> => {
  const response = await fetch('/api/clinical-trials/cancer-types', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    throw new Error(`Clinical trials cancer types failed (${response.status})`);
  }

  const data: ClinicalTrialsCancerTypesResponse = await response.json();
  return Array.isArray(data.cancerTypes) ? data.cancerTypes : [];
};

export const getStudyByNctId = async (
  nctId: string
): Promise<ClinicalTrial | null> => {
  const response = await fetch(
    `/api/clinical-trials/${encodeURIComponent(nctId)}`
  );

  if (response.status === 404) return null;
  if (!response.ok) {
    throw new Error(`Clinical trial details failed (${response.status})`);
  }

  return response.json();
};
